import React, { lazy } from 'react'

const SubmitVideoPage = lazy(() => import('./SubmitVideoPage'))

export { SubmitVideoPage }
